<template>
 <section class="featured sliderhome current-1 wrapper" data-hash="8" id="heroheader">    
   <ul id="scene0" class="current scene game-featured game-1"
        data-friction-x="0.1"
        data-friction-y="0.1"
        data-scalar-x="45"
        data-limit-x="190"
        data-limit-y="220"
        data-scalar-y="25">
        <li class="layer" data-depth="0">
            <img src="../assets/images/Layer1op.jpg" alt="dwerve" class="background"/>
        </li>
          <li class="layer" data-depth="0">
            <img src="../assets/images/Dwerve-Crossbow-349.gif" alt="dwerve" class="crossbow" id="crossbow">
        </li>
        <li class="layer" data-depth="0">
            <img src="../assets/images/Dwerve-Slice-Tower-532.gif" alt="dwerve" class="slice-tower" id="slice-tower">
        </li>
        <li class="layer" data-depth="0.1">
            <img src="../assets/images/Layer2op.png" alt="dwerve" class="images" />
        </li>
        <li class="layer" data-depth="0.2">
            <img src="../assets/images/Layer3op.png" alt="dwerve" class="images" />
        </li>
    </ul>
  
       <HeroText/>
     

</section>
</template>

<script>
import HeroText from "@/components/HeroText.vue";
export default {
  data: function() {
    return {};
  },
  methods: {
    resizeGIFs() {
      var windowWidth = document.documentElement.clientWidth;
      var windowHeight = document.documentElement.clientHeight;
      var actualBackgroundWidth = 1920;
      var actualBackgroundHeight = 1080;
      var targetAspectRatio = 1920 / 1080;
      var actualAspectRatio = windowWidth / windowHeight;
      var actualSliceWidth = 533;
      var actualSliceHeight = 403;
      var sliceAspectRatio = actualSliceWidth / actualSliceHeight;
      var actualSliceDistanceTop = 409;
      var actualSliceDistanceRight = 407;
      var sliceDistanceAspectRatio =
        actualSliceDistanceRight / actualSliceDistanceTop;
      if (actualAspectRatio <= targetAspectRatio) {
        var sliceHeight =
          actualSliceHeight * windowHeight / actualBackgroundHeight;
        var sliceWidth = sliceHeight * sliceAspectRatio;
        var sliceTop =
          actualSliceDistanceTop * windowHeight / actualBackgroundHeight;
        var sliceRight = sliceTop * sliceDistanceAspectRatio;
      } else {
        var sliceWidth = actualSliceWidth * windowWidth / actualBackgroundWidth;
        var sliceHeight = sliceWidth / sliceAspectRatio;
        var sliceRight =
          actualSliceDistanceRight * windowWidth / actualBackgroundWidth;
        var sliceTop = sliceRight / sliceDistanceAspectRatio;
      }
      document.getElementById("slice-tower").style.top = sliceTop + "px";
      document.getElementById("slice-tower").style.right = sliceRight + "px";
      document.getElementById("slice-tower").style.height = sliceHeight + "px";
      document.getElementById("slice-tower").style.width = sliceWidth + "px";
      var actualArrowWidth = 348;
      var actualArrowHeight = 250;
      var arrowAspectRatio = actualArrowWidth / actualArrowHeight;
      var actualArrowDistanceTop = 224;
      var actualArrowDistanceRight = 1220;
      var arrowDistanceAspectRatio =
        actualArrowDistanceRight / actualArrowDistanceTop;
      if (actualAspectRatio <= targetAspectRatio) {
        var arrowHeight =
          actualArrowHeight * windowHeight / actualBackgroundHeight;
        var arrowWidth = arrowHeight * arrowAspectRatio;
        var arrowTop =
          actualArrowDistanceTop * windowHeight / actualBackgroundHeight;
        var arrowRight = arrowTop * arrowDistanceAspectRatio;
      } else {
        var arrowWidth = actualArrowWidth * windowWidth / actualBackgroundWidth;
        var arrowHeight = arrowWidth / arrowAspectRatio;
        var arrowRight =
          actualArrowDistanceRight * windowWidth / actualBackgroundWidth;
        var arrowTop = arrowRight / arrowDistanceAspectRatio;
      }
      document.getElementById("crossbow").style.top = arrowTop + "px";
      document.getElementById("crossbow").style.right = arrowRight + "px";
      document.getElementById("crossbow").style.height = arrowHeight + "px";
      document.getElementById("crossbow").style.width = arrowWidth + "px";
    },
    setZIndex(){
      if(document.getElementById("myFollowModal").style.display == "block") {
        document.getElementById("navbar").style.zIndex = "1";
        document.getElementById("socialNav").style.zIndex = "1"
      }
      else{
        document.getElementById("navbar").style.zIndex = "2";
        document.getElementById("socialNav").style.zIndex = "2"
      }
     
    }
  },
  mounted() {
    this.$nextTick(function() {
      window.addEventListener("resize", this.resizeGIFs);
      this.resizeGIFs();
    });
    ! function(t, i, e) {
    "use strict";

    function s(t, i) {
        this.element = t, this.layers = t.getElementsByClassName("layer");
        var e = {
            calibrateX: this.data(this.element, "calibrate-x"),
            calibrateY: this.data(this.element, "calibrate-y"),
            invertX: this.data(this.element, "invert-x"),
            invertY: this.data(this.element, "invert-y"),
            limitX: this.data(this.element, "limit-x"),
            limitY: this.data(this.element, "limit-y"),
            scalarX: this.data(this.element, "scalar-x"),
            scalarY: this.data(this.element, "scalar-y"),
            frictionX: this.data(this.element, "friction-x"),
            frictionY: this.data(this.element, "friction-y"),
            originX: this.data(this.element, "origin-x"),
            originY: this.data(this.element, "origin-y")
        };
        for (var s in e) null === e[s] && delete e[s];
        this.extend(this, r, i, e), this.calibrationTimer = null, this.calibrationFlag = !0, this.enabled = !1, this.depths = [], this.raf = null, this.bounds = null, this.ex = 0, this.ey = 0, this.ew = 0, this.eh = 0, this.ecx = 0, this.ecy = 0, this.erx = 0, this.ery = 0, this.cx = 0, this.cy = 0, this.ix = 0, this.iy = 0, this.mx = 0, this.my = 0, this.vx = 0, this.vy = 0, this.onMouseMove = this.onMouseMove.bind(this), this.onDeviceOrientation = this.onDeviceOrientation.bind(this), this.onOrientationTimer = this.onOrientationTimer.bind(this), this.onCalibrationTimer = this.onCalibrationTimer.bind(this), this.onAnimationFrame = this.onAnimationFrame.bind(this), this.onWindowResize = this.onWindowResize.bind(this), this.initialise()
    }
    var n = "Parallax",
        o = 30,
        r = {
            relativeInput: !1,
            clipRelativeInput: !1,
            calibrationThreshold: 100,
            calibrationDelay: 500,
            supportDelay: 500,
            calibrateX: !1,
            calibrateY: !0,
            invertX: !0,
            invertY: !0,
            limitX: !1,
            limitY: !1,
            scalarX: 10,
            scalarY: 10,
            frictionX: .1,
            frictionY: .1,
            originX: .5,
            originY: .5
        };
    s.prototype.extend = function() {
        if (arguments.length > 1)
            for (var t = arguments[0], i = 1, e = arguments.length; i < e; i++) {
                var s = arguments[i];
                for (var n in s) t[n] = s[n]
            }
    }, s.prototype.data = function(t, i) {
        return this.deserialize(t.getAttribute("data-" + i))
    }, s.prototype.deserialize = function(t) {
        return "true" === t || "false" !== t && ("null" === t ? null : !isNaN(parseFloat(t)) && isFinite(t) ? parseFloat(t) : t)
    }, s.prototype.camelCase = function(t) {
        return t.replace(/-+(.)?/g, function(t, i) {
            return i ? i.toUpperCase() : ""
        })
    }, s.prototype.transformSupport = function(s) {
        for (var n = i.createElement("div"), o = !1, r = null, a = !1, h = null, l = null, p = 0, c = this.vendors.length; p < c; p++)
            if (null !== this.vendors[p] ? (h = this.vendors[p][0] + "transform", l = this.vendors[p][1] + "Transform") : (h = "transform", l = "transform"), n.style[l] !== e) {
                o = !0;
                break
            } switch (s) {
            case "2D":
                a = o;
                break;
            case "3D":
                if (o) {
                    var m = i.body || i.createElement("body"),
                        u = i.documentElement,
                        y = u.style.overflow;
                    i.body || (u.style.overflow = "hidden", u.appendChild(m), m.style.overflow = "hidden", m.style.background = ""), m.appendChild(n), n.style[l] = "translate3d(1px,1px,1px)", r = t.getComputedStyle(n).getPropertyValue(h), a = r !== e && r.length > 0 && "none" !== r, u.style.overflow = y, m.removeChild(n)
                }
        }
        return a
    }, s.prototype.ww = null, s.prototype.wh = null, s.prototype.wcx = null, s.prototype.wcy = null, s.prototype.wrx = null, s.prototype.wry = null, s.prototype.portrait = null, s.prototype.desktop = !navigator.userAgent.match(/(iPhone|iPod|iPad|Android|BlackBerry|BB10|mobi|tablet|opera mini|nexus 7)/i), s.prototype.vendors = [null, ["-webkit-", "webkit"],
        ["-moz-", "Moz"],
        ["-o-", "O"],
        ["-ms-", "ms"]
    ], s.prototype.motionSupport = !!t.DeviceMotionEvent, s.prototype.orientationSupport = !!t.DeviceOrientationEvent, s.prototype.orientationStatus = 0, s.prototype.transform2DSupport = s.prototype.transformSupport("2D"), s.prototype.transform3DSupport = s.prototype.transformSupport("3D"), s.prototype.propertyCache = {}, s.prototype.initialise = function() {
        this.transform3DSupport && this.accelerate(this.element);
        var i = t.getComputedStyle(this.element);
        "static" === i.getPropertyValue("position") && (this.element.style.position = "relative"), this.updateLayers(), this.updateDimensions(), this.enable(), this.queueCalibration(this.calibrationDelay)
    }, s.prototype.updateLayers = function() {
        this.layers = this.element.getElementsByClassName("layer"), this.depths = [];
        for (var t = 0, i = this.layers.length; t < i; t++) {
            var e = this.layers[t];
            this.transform3DSupport && this.accelerate(e), e.style.position = t ? "absolute" : "relative", e.style.display = "block", e.style.left = 0, e.style.top = 0, this.depths.push(this.data(e, "depth") || 0)
        }
    }, s.prototype.updateDimensions = function() {
        this.ww = t.innerWidth, this.wh = t.innerHeight, this.wcx = this.ww * this.originX, this.wcy = this.wh * this.originY, this.wrx = Math.max(this.wcx, this.ww - this.wcx), this.wry = Math.max(this.wcy, this.wh - this.wcy)
    }, s.prototype.updateBounds = function() {
        this.bounds = this.element.getBoundingClientRect(), this.ex = this.bounds.left, this.ey = this.bounds.top, this.ew = this.bounds.width, this.eh = this.bounds.height, this.ecx = this.ew * this.originX, this.ecy = this.eh * this.originY, this.erx = Math.max(this.ecx, this.ew - this.ecx), this.ery = Math.max(this.ecy, this.eh - this.ecy)
    }, s.prototype.queueCalibration = function(t) {
        clearTimeout(this.calibrationTimer), this.calibrationTimer = setTimeout(this.onCalibrationTimer, t)
    }, s.prototype.enable = function() {
        this.enabled || (this.enabled = !0, this.orientationSupport ? (this.portrait = null, t.addEventListener("deviceorientation", this.onDeviceOrientation), setTimeout(this.onOrientationTimer, this.supportDelay)) : (this.cx = 0, this.cy = 0, this.portrait = !1, t.addEventListener("mousemove", this.onMouseMove)), t.addEventListener("resize", this.onWindowResize), this.raf = requestAnimationFrame(this.onAnimationFrame))
    }, s.prototype.disable = function() {
        this.enabled && (this.enabled = !1, this.orientationSupport ? t.removeEventListener("deviceorientation", this.onDeviceOrientation) : t.removeEventListener("mousemove", this.onMouseMove), t.removeEventListener("resize", this.onWindowResize), cancelAnimationFrame(this.raf))
    }, s.prototype.calibrate = function(t, i) {
        this.calibrateX = t === e ? this.calibrateX : t, this.calibrateY = i === e ? this.calibrateY : i
    }, s.prototype.invert = function(t, i) {
        this.invertX = t === e ? this.invertX : t, this.invertY = i === e ? this.invertY : i
    }, s.prototype.friction = function(t, i) {
        this.frictionX = t === e ? this.frictionX : t, this.frictionY = i === e ? this.frictionY : i
    }, s.prototype.scalar = function(t, i) {
        this.scalarX = t === e ? this.scalarX : t, this.scalarY = i === e ? this.scalarY : i
    }, s.prototype.limit = function(t, i) {
        this.limitX = t === e ? this.limitX : t, this.limitY = i === e ? this.limitY : i
    }, s.prototype.origin = function(t, i) {
        this.originX = t === e ? this.originX : t, this.originY = i === e ? this.originY : i
    }, s.prototype.clamp = function(t, i, e) {
        return t = Math.max(t, i), t = Math.min(t, e)
    }, s.prototype.css = function(t, i, s) {
        var n = this.propertyCache[i];
        if (!n)
            for (var o = 0, r = this.vendors.length; o < r; o++)
                if (n = null !== this.vendors[o] ? this.camelCase(this.vendors[o][1] + "-" + i) : i, t.style[n] !== e) {
                    this.propertyCache[i] = n;
                    break
                } t.style[n] = s
    }, s.prototype.accelerate = function(t) {
        this.css(t, "transform", "translate3d(0,0,0)"), this.css(t, "transform-style", "preserve-3d"), this.css(t, "backface-visibility", "hidden")
    }, s.prototype.setPosition = function(t, i, e) {
        i += "px", e += "px", this.transform3DSupport ? this.css(t, "transform", "translate3d(" + i + "," + e + ",0)") : this.transform2DSupport ? this.css(t, "transform", "translate(" + i + "," + e + ")") : (t.style.left = i, t.style.top = e)
    }, s.prototype.onOrientationTimer = function(t) {
        this.orientationSupport && 0 === this.orientationStatus && (this.disable(), this.orientationSupport = !1, this.enable())
    }, s.prototype.onCalibrationTimer = function(t) {
        this.calibrationFlag = !0
    }, s.prototype.onWindowResize = function(t) {
        this.updateDimensions()
    }, s.prototype.onAnimationFrame = function() {
        this.updateBounds();
        var t = this.ix - this.cx,
            i = this.iy - this.cy;
        (Math.abs(t) > this.calibrationThreshold || Math.abs(i) > this.calibrationThreshold) && this.queueCalibration(0), this.portrait ? (this.mx = this.calibrateX ? i : this.iy, this.my = this.calibrateY ? t : this.ix) : (this.mx = this.calibrateX ? t : this.ix, this.my = this.calibrateY ? i : this.iy), this.mx *= this.ew * (this.scalarX / 100), this.my *= this.eh * (this.scalarY / 100), isNaN(parseFloat(this.limitX)) || (this.mx = this.clamp(this.mx, -this.limitX, this.limitX)), isNaN(parseFloat(this.limitY)) || (this.my = this.clamp(this.my, -this.limitY, this.limitY)), this.vx += (this.mx - this.vx) * this.frictionX, this.vy += (this.my - this.vy) * this.frictionY;
        for (var e = 0, s = this.layers.length; e < s; e++) {
            var n = this.layers[e],
                o = this.depths[e],
                r = this.vx * o * (this.invertX ? -1 : 1),
                a = this.vy * o * (this.invertY ? -1 : 1);
            this.setPosition(n, r, a)
        }
        this.raf = requestAnimationFrame(this.onAnimationFrame)
    }, s.prototype.onDeviceOrientation = function(t) {
        if (!this.desktop && null !== t.beta && null !== t.gamma) {
            this.orientationStatus = 1;
            var i = (t.beta || 0) / o,
                e = (t.gamma || 0) / o,
                s = this.wh > this.ww;
            this.portrait !== s && (this.portrait = s, this.calibrationFlag = !0), this.calibrationFlag && (this.calibrationFlag = !1, this.cx = i, this.cy = e), this.ix = i, this.iy = e
        }
    }, s.prototype.onMouseMove = function(t) {
        var i = t.clientX,
            e = t.clientY;
        !this.orientationSupport && this.relativeInput ? (this.clipRelativeInput && (i = Math.max(i, this.ex), i = Math.min(i, this.ex + this.ew), e = Math.max(e, this.ey), e = Math.min(e, this.ey + this.eh)), this.ix = (i - this.ex - this.ecx) / this.erx, this.iy = (e - this.ey - this.ecy) / this.ery) : (this.ix = (i - this.wcx) / this.wrx, this.iy = (e - this.wcy) / this.wry)
    }, t[n] = s
}(window, document),
function() {
    for (var t = 0, i = ["ms", "moz", "webkit", "o"], e = 0; e < i.length && !window.requestAnimationFrame; ++e) window.requestAnimationFrame = window[i[e] + "RequestAnimationFrame"], window.cancelAnimationFrame = window[i[e] + "CancelAnimationFrame"] || window[i[e] + "CancelRequestAnimationFrame"];
    window.requestAnimationFrame || (window.requestAnimationFrame = function(i, e) {
        var s = (new Date).getTime(),
            n = Math.max(0, 16 - (s - t)),
            o = window.setTimeout(function() {
                i(s + n)
            }, n);
        return t = s + n, o
    }), window.cancelAnimationFrame || (window.cancelAnimationFrame = function(t) {
        clearTimeout(t)
    })
}
();
(function() {
    $(document).ready(function() {
        (window.jQuery), 
        $(function() {
            function e(r, i) {
                var s = l[n],
                    c = "current-" + n;
                if (!(o <= 1)) {
                    clearTimeout(t);
                    var d = ".game-" + n;
                    if (1 === r ? n === o ? n = 1 : n++ : r === -1 ? 1 === n ? n = o : n-- : r = 1, t = setTimeout(e, i, 1, a), $("body.intro").length > 0) {
                        var u = "current-" + n,
                            f = ".game-" + n,
                            m = $(f),
                            p = $(d);
                        void 0 === l[n] && (l[n] = new Parallax(document.getElementsByClassName("game-" + n)[0])), p.removeClass("current"), m.addClass("current"), $(".sliderhome").removeClass(c).addClass(u), void 0 !== s && s.disable(), l[n].enable()
                    }
                }
            }
            var t, n = 1,
                a = 1e4,
                r = 15e3,
                l = [],
                o = $(".scene.game-featured").length;
            "function" == typeof Parallax && o > 0 && (l[n] = l[n] || new Parallax($(".scene.current")[0])), o <= 1 || ($(".game-featured").on("click", function() {
                e(1, r)
            }), e(0, a))
        })
    })
})(jQuery);
  },
  beforeDestroy() {
    window.removeEventListener("resize", this.resizeGIFs);
  },
  components: {
    HeroText
  }
};
</script>


<style scoped>
.fixed-title{
  width: 100%;
    display: block;
    position: absolute;
    top: 0;
    text-align: center;
}
iframe#sm_iframe {
   border: 11px solid rgba(255, 255, 255, 0.77) !important;
    border-radius: 6px;
    box-shadow: 0 14px 28px rgba(0,0,0,0.25), 0 10px 10px rgba(0,0,0,0.22);
    padding: 5px;
    background: #f7f6f2;
        height: 507px !important;
}
i.fas.fa-chevron-down.animated.pulse.animated-infinite {
    bottom: 11px;
    position: absolute;
    text-align: center;
    width: 100%;
}
.fa-chevron-down:before {
    color: rgba(255, 255, 255, 0.30196078431372547);
    font-size: 20px;
}
@font-face {
  font-family: Digitalt;
  src: url(../assets/lib/Digitalt.otf);
}
.follow-title {
  font-family: Digitalt;
  color: #33adff;
  font-size: 58px;
}
.follow-subtitle {
  font-family: Digitalt;
  font-size: 26px;
}
.follow-subtitle2 {
  font-family: Digitalt;
  font-size: 23px;
  color: #febf45;
  margin: 0 0 0px;
  line-height: 1;
  font-weight: 100;
  padding-top: 0px;
}
.slice-tower,
.game-title .crossbow {
  min-width: unset;
  width: unset;
  max-width: unset;
  min-height: unset;
  height: unset;
  margin: 0 auto;
}

.follow-btn {
  width: 402px;
}

.crossbow {
  position: absolute;
  object-fit: contain;
  left: unset;
  bottom: unset;
  min-width: unset;
  min-height: unset;
}

.slice-tower {
  position: absolute;
  left: unset;
  object-fit: contain;
  bottom: unset;
}

.subtitle-img {
  z-index: 9;
  left: 19%;
  top: 2%;
  position: absolute;
}

.fade-in.three {
  -webkit-animation-delay: 2.6s;
  -moz-animation-delay: 2.6s;
  animation-delay: 2.6s;
}

.fade-in {
  opacity: 0; /* make things invisible upon start */
  -webkit-animation: fadeIn ease-in 1;
  -moz-animation: fadeIn ease-in 1;
  animation: fadeIn ease-in 1;

  -webkit-animation-fill-mode: forwards;
  -moz-animation-fill-mode: forwards;
  animation-fill-mode: forwards;

  -webkit-animation-duration: 1s;
  -moz-animation-duration: 1s;
  animation-duration: 1s;
}
@-webkit-keyframes fadeIn {
  from {
    opacity: 0;
  }
  to {
    opacity: 1;
  }
}
@-moz-keyframes fadeIn {
  from {
    opacity: 0;
  }
  to {
    opacity: 1;
  }
}
@keyframes fadeIn {
  from {
    opacity: 0;
  }
  to {
    opacity: 1;
  }
}

.follow::before,
.follow::after {
  position: absolute;
  content: "";
  transition: all 0.5s;
}
.follow {
  position: absolute;
  top: 93%;
  left: 51%;
  -webkit-transform: translate(-50%, -50%);
  transform: translate(-50%, -50%);
}

.suscribe {
  margin-left: 50%;
  margin-top: 48%;
  transform: translateZ(600px);
}

.parallax {
  position: relative;
  width: 100%;
  height: 800px;
  left: 0;
}

.cd-floating-background {
  position: absolute;
  right: 0;
}
.cd-background-wrapper {
  width: 100%;
  height: 100vh;
  overflow: hidden;
  background-size: cover;
  position: relative;
}

.dwerveTitle {
 
}

.background {
  position: absolute;
  z-index: -1;
  min-width: unset;
  margin: auto;
  width: 100% !important;
  min-width: unset;
  min-height: unset;
  top: unset;
  bottom: unset;
  object-fit: cover;
  object-position: 100% 100% !important;
}

@media (min-aspect-ratio: 16 / 9) {
  .images {
    width: 104.17%;
    height: auto;
    margin-top: 0;
    object-position: 95.83% 100%;
  }
  .dwerveTitle {
    bottom: 0;
    top: 33% !important;
    margin-top: auto !important;
  }
  .follow {
    top: 90%;
  }
  .background {
    height: auto;
  }
}

@media (max-aspect-ratio: 16 / 9) {
  .images {
    width: 104.17%;
    object-position: 95.83% 100%;
  }
 img.game-title.dwerveTitle {
    margin: 0 auto;
    top: 0;
}
  .follow {
    top: 87%;
  }
  .background {
    height: 100%;
  }
}

@media only screen and (max-width: 1070px) {
  .background{
    object-position: 50% 100% !important;
  }

 
  .follow {
    font-size: 5vw;
  }
  .slice-tower {
    display: none;
  }
}
@media only screen and (min-width: 500px) and (max-width: 600px) {
  .dwerveTitle {
    width: 85% !important;
    margin-bottom: 19%;
    left: -2% !important;
  }
  .follow {
    font-size: 3vw;
    top: 81%;
  }
}
@media only screen and (min-width: 200px) and (max-width: 600px) {
  .dwerveTitle {
   margin-bottom: 40% !important;
  }
  .follow {
    font-size: 3vw;
    top: 90%;
  }
}
@media only screen and (min-width: 600px) and (max-width: 800px) {
  .dwerveTitle {
    width: 83% !important;
    top: 40% !important;
    left: -4% !important;
  }
  .follow {
    font-size: 3vw;
    top: 90%;
  }
}
@media only screen and (min-width: 800px) and (max-width: 900px) {
  .dwerveTitle {
    width: 85% !important;
    top: 59% !important;
    left: 0% !important;
  }
  .follow {
    font-size: 3vw;
  }
}
@media only screen and (min-width: 900px) and (max-width: 1100px) {
  .dwerveTitle {
    width: 74% !important;
    top: 39% !important;
    left: 0% !important;
  }
  .follow {
    font-size: 2.6vw;
  }
}
@media only screen and (width: 1024) {
  .dwerveTitle {
    width: 70% !important;
    margin-bottom: 21%;
    left: 16% !important;
  }
}

@media (width: 375px) {
  .dwerveTitle {
    margin-bottom: 27%;
  }
}

.spider-hanging {
  position: absolute;
  top: -115%;
  width: 15%;
}
.overlay {
  /* Height & width depends on how you want to reveal the overlay (see JS below) */
  height: 100%;
  width: 100%;
  position: fixed; /* Stay in place */
  z-index: 1; /* Sit on top */
  left: 0;
  top: 0;
  display: none;
  background-color: rgb(0, 0, 0); /* Black fallback color */
  background-color: #0d182de6; /* Black w/opacity */
  overflow-x: hidden; /* Disable horizontal scroll */
  transition: 0.5s; /* 0.5 second transition effect to slide in or slide down the overlay (height or width, depending on reveal) */
}

/* Position the content inside the overlay */
.overlay-content {
  position: relative;
  top: 21%;
  width: 54%;
  left: 25%;
  text-align: center;
  margin-top: 30px;
}

/* The navigation links inside the overlay */
.overlay a {
  padding: 8px;
  text-decoration: none;
  font-size: 36px;
  color: #fff;
  display: block; /* Display block instead of inline */
  transition: 0.3s; /* Transition effects on hover (color) */
}
.overlay-content input#semail {
  height: 69px;
}
@media screen and (max-height: 750px) {
  .overlay-content {
    position: relative;
    top: 30%;
    width: auto;
    left: 0;
    text-align: center;
    margin-top: 0;
}
}

/* When you mouse over the navigation links, change their color */
.overlay a:hover,
.overlay a:focus {
  color: #f1f1f1;
}

/* Position the close button (top right corner) */
.overlay .closebtn {
  position: absolute;
  top: 20px;
  right: 45px;
  font-size: 60px;
  z-index: 1;
}

/* When the height of the screen is less than 450 pixels, change the font-size of the links and position the close button again, so they don't overlap */
@media screen and (max-height: 450px) {
  .overlay a {
    font-size: 20px;
  }
  .overlay .closebtn {
    font-size: 40px;
    top: 15px;
    right: 35px;
  }
}
.follow-form {
  padding-top: 0px;
  width: 53%;
  margin-left: 24%;
}
.fade-in-overlay {
  opacity: 1;
  animation-name: fadeInOpacity;
  animation-iteration-count: 1;
  animation-timing-function: ease-in;
  animation-duration: 0.2s;
}

@keyframes fadeInOpacity {
  0% {
    opacity: 0;
  }
  100% {
    opacity: 1;
  }
}
#heroheader .col-xs-12 {
  padding-left: 0%;
  padding-right: 0%;
  z-index: 1;
}
@media only screen and (max-width: 768px) {
  .col-xs-12 {
    padding-left: 13%;
    padding-right: 13%;
  }
}
@media only screen and (max-width: 768px) {
  .col-xs-12 {
    padding-left: 13%;
    padding-right: 13%;
  }

  section#cta1 button {
    width: 112px;
    font-size: 22px;
    padding-left: 10px !important;
}
}
/* Mailtrain styles */
#heroheader .form-group.email label {
  display: none;
}
#heroheader .form-group {
  display: inline-block;
}

#heroheader .form-group.email input {
  top: -9px;
  left: 6px;
}
#heroheader .form-group.email label {
  display: none;
}
/* div#mailtrain-subscription-widget-rJfit7pAM h3 {
  display: none;
} */
#heroheader .mailtrain-subscription-widget h3 {
  display: none;
}
h3.cta-title {
  display: block;
}
@media only screen and (min-device-width: 600px) and (max-device-width: 780px) {
  #heroheader form.form button {
    font-size: 24px;
  }
}
@media only screen and (min-device-width: 300px) and (max-device-width: 600px) {
  #heroheader form.form button {
    font-size: 19px;
    height: 39px;
        width: 132px;
  }
  #heroheader .form-group.email input {
    height: 39px;
  }
  .cta-subtitle {
    padding-top: 32px;
  }
  .follow-title {
    font-size: 26px;
  }
  .follow-subtitle {
    font-size: 14px;
  }
  .follow-subtitle2 {
    font-size: 18px !important;
    padding-top: 0px;
  }
  .images {
    width: 121.17%;
  }
}
</style>
